module.exports = __webpack_public_path__ + "img/seed-analyzer-bg.5b787232.png";